// extracted by mini-css-extract-plugin
module.exports = {"container":"_242aff3","tag":"_e52c6a3"};